import { request } from "../libs";
import { getISODateFromTicks } from "../utils";

function fetchAggregatorsDetails({ domain, aggregator }) {
	return request(
		`/server/${domain}/aggregators/${aggregator}`,
		{
			method: "GET"
		}
	)
		.then(r => r.json())
		.then(res => {
			switch (aggregator) {
				case "countAnswersPerFormPerUser": {
					let answerCount = 0;
					res.result.forEach(userAnswer => {
						answerCount += userAnswer.instances;
					});
					res = {
						name: "Answers per Form per User",
						table: res.result,
						headers: [
							{ text: "User", align: "start", value: "user" },
							{ text: "Answers", value: "instances" }
						],
						result: `${res.result.length} users and ${answerCount} answers in total`
					};
					break;
				}
				case "lastChanged": {
					res.name = "Last Changed";
					res.result = res.result.date ? getISODateFromTicks(res.result.date) : "-";
					break;
				}
				case "lastBackup": {
					res.name = "Last Backup";
					break;
				}
				case "lastAuth": {
					res.name = "Last Auth";
					res.result = res.result.date ? getISODateFromTicks(res.result.date) : "-";
					break;
				}
				case "noRegisteredUsers": {
					res.name = "Registered Users";
					break;
				}
				case "noActiveUsers": {
					res.name = "Active Users";
					break;
				}
				case "noDatum": {
					res.name = "Number of Datum";
					break;
				}
				case "noForms": {
					res.name = "Number of Forms";
					break;
				}
				default: {
					break;
				}
			}
			return res;
		});
}

export default fetchAggregatorsDetails;



// WEBPACK FOOTER //
// ./src/api/fetch-aggregators-details.js